module.exports = __WEBPACK_EXTERNAL_MODULE_ngx_toastr__;